export function TechSection() {
  const technologies = [
    {
      name: 'TypeScript',
      icon: '/icons/typescript.svg',
    },
    {
      name: 'Python',
      icon: '/icons/python.svg',
    },
    {
      name: 'React',
      icon: '/icons/react.svg',
    },
    {
      name: 'Node.js',
      icon: '/icons/nodejs.svg',
    },
    {
      name: 'PostgreSQL',
      icon: '/icons/postgresql.svg',
    },
    {
      name: 'Kafka',
      icon: '/icons/kafka.svg',
    },
  ];

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          @media (max-width: 768px) {
            .mobile-tech-section {
              padding: 40px 20px !important;
            }
            .mobile-tech-container {
              padding: 40px 20px !important;
            }
            .mobile-tech-grid {
              grid-template-columns: repeat(3, 1fr) !important;
              gap: 16px !important;
              height: auto !important;
            }
            .mobile-tech-card {
              padding: 24px 16px !important;
            }
            .mobile-tech-title {
              font-size: 24px !important;
              line-height: 32px !important;
            }
            .mobile-tech-subtitle {
              font-size: 12px !important;
              line-height: 18px !important;
            }
            .mobile-tech-name {
              font-size: 10px !important;
            }
          }
        `,
        }}
      />
      <div className="w-full py-[40px] bg-slate-950 flex justify-center items-center mobile-tech-section">
        <div className="w-full max-w-[1200px] px-[60px] py-10 bg-slate-950 flex flex-col justify-start items-start gap-14 mobile-tech-container">
          <div className="w-full flex flex-col justify-start items-start gap-3">
            <div className="w-full flex flex-col justify-start items-center">
              <div
                className="text-center justify-center text-3xl font-bold font-['Inter'] mobile-tech-title"
                style={{ color: '#FAFAFA' }}
              >
                Teknoloji Yığını
              </div>
            </div>
            <div className="w-full flex flex-col justify-start items-center">
              <div
                className="text-center justify-center text-sm font-normal font-['Inter'] mobile-tech-subtitle"
                style={{ color: 'rgba(255, 255, 255, 0.25)' }}
              >
                Ürünlerimizi besleyen temel teknolojiler
              </div>
            </div>
          </div>

          <div className="w-full h-44 grid grid-cols-6 gap-4 mobile-tech-grid">
            {technologies.map((tech, index) => (
              <div
                key={index}
                className="w-full py-14 bg-neutral-900 rounded-2xl outline outline-1 outline-offset-[-1px] outline-white/5 flex flex-col justify-center items-center gap-2.5 mobile-tech-card transition-all duration-300 cursor-pointer hover:border-[rgba(118,188,232,0.20)] hover:bg-[#111] hover:shadow-[0_20px_60px_0_rgba(0,0,0,0.40)]"
                style={{
                  boxShadow: '0px 4px 40px 0px rgba(0, 150, 196, 0.25)',
                }}
              >
                <img src={tech.icon} alt={tech.name} className="size-7" />
                <div className="flex flex-col justify-start items-start">
                  <div
                    className="justify-center text-xs font-semibold font-['Inter'] mobile-tech-name"
                    style={{ color: 'rgba(255, 255, 255, 0.25)' }}
                  >
                    {tech.name}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
